jQuery(document).ready(($) => {

    $("#accordion__neck-numbers .pane__header button").click(function() {

        if($(this).attr('aria-expanded') == 'false'){
            inactiveOthers ();

            var termTarget = $(this).attr('data-target');
            termTarget = termTarget.match(/--([^ ]*)/)[1];

            $('#neck-numbers-svg [data-target^="' + termTarget +'"]').removeClass('inactive').addClass('active');

        }else{
            resetAll();
        }
    });

    $("#neck-numbers-svg .svg").click(function() {
        var termTarget = $(this).attr('data-target');
        termTarget = '#heading--' + termTarget + ' button';

        $(termTarget).click();
    });

    function inactiveOthers (){
        $('#neck-numbers-svg .svg').removeClass('active').addClass('inactive');
    }

    function resetAll (){
        $('#neck-numbers-svg .svg').removeClass('active inactive');
    }


    /*
        NECK LETTERS
    */

    var neckLettersIndex = [
        'letter-t',
        'letter-e',
        'letter-i',
        'letter-s',
        'letter-h'
    ];

    hideHighlights();

    $("#accordion__neck-letters .pane__header button").click(function() {

        if($(this).attr('aria-expanded') == 'false'){
            hideHighlights();
            var termTarget = $(this).attr('data-target');
            termTarget = termTarget.match(/--([^ ]*)/)[1];
            
            $('#neck-letters-svg [id^="letter-' + termTarget +'"]').attr('class', '');
        }else {
            hideHighlights();
        }
    });

    function hideHighlights() {
        $.each( neckLettersIndex, function( key, value ) {
            $('#neck-letters-svg [id^="' + value +'"]').attr('class', 'd-none');
        });
    };

});